module.exports = ['$scope', 'curriculumManager', 'bibContentManager', '$location', 'odetManager', '$state',
  function ($scope, CurriculumManager, bibContentManager, $location, odetManager, $state) {
    'use strict';
    $scope.$state = $state;
    $scope.selected = {};
    $scope.options = {};

    $scope.pagesoptions = [
      {
        title: 'illustraties',
        state: 'bib.search.illustration'
      },
      {
        title: 'klaspraktijk',
        state: 'bib.search.class'
      },
      {
        title: 'begrippen',
        state: 'bib.search.term'
      },
      {
        title: 'concordanties',
        state: 'bib.search.concordanties'
      }
    ];
    $scope.$watch(function () { return $state.$current.name; }, function (newVal, oldVal) {
      $scope.pageSelected = _.find($scope.pagesoptions, {state: newVal});
    });


    $scope.setState = function () {
      //Set query parameters to url
      var k;
      var params = {};
      var searchState = $state.current.name;
      if(searchState === 'bib.search.term.display') {
        searchState = 'bib.search.term';
      }
      for (k in $scope.selected) {
        if (typeof $scope.selected[k] === 'object') {
          params[k] = $scope.selected[k].key;
        } else {
          params[k] = $scope.selected[k];
        }
      }
      params.offset = 0;
      $state.go(searchState, params, { notify: false, location: true });
    };

    $scope.clear = function () {
      var k = 0;

      for (k in $scope.selected) {
        if ($scope.selected.hasOwnProperty(k)) {
          if (k === 'q') {
            $scope.selected[k] = '';
          } else if (k === 'ageFrom') {
            $scope.selected[k] = 2;
          }else if (k === 'ageTo') {
            $scope.selected[k] = 12;
          } else if ($scope.options[k]) {
            $scope.selected[k] = $scope.options[k][0];
          }
        }
      }
    };

    CurriculumManager.getFields().then(function (fields) {
      $scope.fields = fields;
    });

    $scope.changeField = function (field) {
      console.log('change');
      if (field.type !== 'static') {
        $scope.selected.theme = field.themes[0]; //set first as selected
        $scope.selected.goal = {};
      } else {
        $scope.selected.theme = {};
        $scope.selected.goal = {};
      }
    };

    $scope.changeTheme = function (theme) {
      if (theme.goals) {
        $scope.selected.goal = theme.goals[0]; //set first as selected
      }
    };

  }
];



// WEBPACK FOOTER //
// ./web/js/screen/bib/search/bibSearchController.js